import React from 'react';
import { file_url } from 'constant/url';
import { useTranslation } from "react-i18next";
import { useCommonContentQuery } from "../../redux/features/common/commonApi";

const AppIntro = () => {
    const { t } = useTranslation();
    const { data } = useCommonContentQuery();
    return (
        <>
            <h1 className="medium_font mb-3">{t("settings.app_intro.intro_text")}</h1>
            <dt className="small_font fw-medium mb-3" style={{ color: 'var(--text-gray)' }}>{data?.data?.intro_media?.description}</dt>

            <video autoPlay={true} muted controls className="video_style w-100 h-auto">
                <source src={`${file_url}${data?.data?.intro_media?.link}`} type="video/mp4" />
                <source src={`${file_url}${data?.data?.intro_media?.link}`} type="video/ogg" />
                <track kind="captions" />
            </video>
        </>
    )
}

export default AppIntro;